import { TransactionHistoryRequest, TransactionHistoryItem } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useTransactionHistory({ bearer }: { bearer?: string } = {}) {
  const source = axios.CancelToken.source();
  const [transactionHistory, setTransactionHistory] = useState<TransactionHistoryItem[]>([]);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const fetchTransactionHistory = async (request: TransactionHistoryRequest) => {
    try {
      const res = await api.fetchTransactionHistory(request, bearer, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setTransactionHistory(res.TransactionHistory);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    transactionHistory,
    fetchTransactionHistory,
  };
}
